import { connect } from "formik";

import Assets from "./Assets";

export default connect(Assets);
